const PRODUCT_TYPES = new Set(['master', 'listing']);
const VARIANT_TYPES = new Set(['masterVariant', 'listingVariant']);

/**
 * Wire shape for POST /images/search `productSelection` from the current
 * Product / Variant bulk selection. Returns null when the selection cannot
 * form a valid request.
 */
export default function buildProductSelectionSearchBody(selection) {
  if (!selection?.keys?.length || !selection.context) return null;

  const productIds = [];
  const variantIds = [];

  selection.keys.forEach((key) => {
    const entry = selection.byKey?.[key];
    if (!entry?._id) return;

    if (VARIANT_TYPES.has(entry.type)) {
      variantIds.push(String(entry._id));
      return;
    }

    if (PRODUCT_TYPES.has(entry.type)) {
      productIds.push(String(entry._id));
    }
  });

  if (!productIds.length && !variantIds.length) return null;

  const { context } = selection;
  const body = {};

  if (productIds.length) body.productIds = productIds;
  if (variantIds.length) body.variantIds = variantIds;

  if (context.type === 'master') {
    return { layer: 'master', ...body };
  }

  if (context.type === 'channel' && context.channelId && context.recordState) {
    return {
      layer: String(context.channelId),
      recordState: context.recordState,
      ...body,
    };
  }

  return null;
}
